var exports = {
  "Ve": "ThemeTab.module__themeButtonGroup___VEpCUG",
  "mB": "ThemeTab.module__themeButton___VEpCUG",
  "RL": "ThemeTab.module__themeButtonSelected___VEpCUG",
  "Uk": "ThemeTab.module__themeButtonLight___VEpCUG",
  "sy": "ThemeTab.module__themeButtonDark___VEpCUG",
  "H2": "ThemeTab.module__themeButtonIcon___VEpCUG",
  "zO": "ThemeTab.module__themeButtonCheckmark___VEpCUG",
  "Qs": "ThemeTab.module__themeButtonCheckmarkIcon___VEpCUG",
};

module.exports = exports;
